import type { Model } from "../data/models";

type CharacterProps = {
  x: number;
  y: number;
  model?: Pick<Model, "skin" | "hair" | "hairLength"> | undefined;
  scale?: number;
  size?: number;
};

export function Character({ x, y, model, scale = 1, size = 32 }: CharacterProps) {
  if (!model) return null;
  const skin = model.skin;
  const hair = model.hair;
  const longHair = model.hairLength === "long";
  const s = size / 32;
  return (
    <g transform={`translate(${x}, ${y}) scale(${scale})`}>
      {longHair && (
        <g>
          <path
            d={`M ${-11 * s} ${-3 * s} Q ${-15 * s} ${5 * s} ${-13 * s} ${17 * s} L ${-7 * s} ${17 * s} Q ${-8 * s} ${6 * s} ${-9 * s} ${-3 * s} Z`}
            fill={hair}
          />
          <path
            d={`M ${11 * s} ${-3 * s} Q ${15 * s} ${5 * s} ${13 * s} ${17 * s} L ${7 * s} ${17 * s} Q ${8 * s} ${6 * s} ${9 * s} ${-3 * s} Z`}
            fill={hair}
          />
        </g>
      )}
      <circle cx="0" cy="0" r={11 * s} fill={skin} />
      {longHair ? (
        <path
          d={`M ${-12 * s} ${-2 * s} Q ${-13 * s} ${-14 * s} 0 ${-14 * s} Q ${13 * s} ${-14 * s} ${12 * s} ${-2 * s} L ${9 * s} ${-4 * s} Q 0 ${-9.5 * s} ${-9 * s} ${-4 * s} Z`}
          fill={hair}
        />
      ) : (
        <path
          d={`M ${-11 * s} ${-2 * s} Q ${-11 * s} ${-13 * s} 0 ${-13 * s} Q ${11 * s} ${-13 * s} ${11 * s} ${-2 * s} L ${8 * s} ${-4 * s} Q 0 ${-9 * s} ${-8 * s} ${-4 * s} Z`}
          fill={hair}
        />
      )}
      <circle cx={-3 * s} cy={0} r={1 * s} fill="#1a1208" />
      <circle cx={3 * s} cy={0} r={1 * s} fill="#1a1208" />
      <path
        d={`M ${-3 * s} ${4 * s} Q 0 ${6.5 * s} ${3 * s} ${4 * s}`}
        stroke="#1a1208"
        strokeWidth={1 * s}
        fill="none"
        strokeLinecap="round"
      />
    </g>
  );
}
